import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sim-detail-card',
  imports: [],
  template: '<ng-content />',
  styleUrl: './detail-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'detail-card'
  }
})
export class SimDetailCardComponent {}
